import common from './common'
import app from './app'
import edit from './edit'
import table from './table'
import tree from './tree'
import custom from './custom'
import op from './op'

export default {
  common,
  app,
  edit,
  table,
  tree,
  ...custom,
  ...op
}